import { getExemplarImageURL } from '.';
import { AWSImage } from '../types';

export const spliceImageToStart = (uuid: string, imagesToShow: AWSImage[], relatedImages: AWSImage[]): void => {
  imagesToShow.splice(0, 0, {
    url: getExemplarImageURL(uuid, relatedImages),
    uuid: uuid,
  });
};

export const sortProformaImagesByCurrentUUID = (currentImageUUID: string, imagesToShow: AWSImage[]): void => {
  imagesToShow.sort((first: AWSImage, second: AWSImage) => {
    return first.uuid == currentImageUUID ? -1 : second.uuid == currentImageUUID ? 1 : 0;
  });
};

export const sortExemplarImagesByCurrentUUID = (
  imageUUID: string,
  imagesToShow: AWSImage[],
  relatedImages: AWSImage[]
): void => {
  const image = imagesToShow.find(({ uuid }) => uuid === imageUUID);
  image === undefined
    ? spliceImageToStart(imageUUID, imagesToShow, relatedImages)
    : imagesToShow.sort((first: AWSImage, second: AWSImage) => {
        return first.uuid == imageUUID ? -1 : second.uuid == imageUUID ? 1 : 0;
      });
};
